var React = require("react");

var ApplicationContext = require("../../config/ApplicationContext.js");

class Confirm extends React.Component {

    constructor() {
        super();
        
        this.state = {checkboxResults: []}

        this.checkboxChanged = this.checkboxChanged.bind(this);
    }

    componentWillReceiveProps(nextProps, nextState){
        if(nextProps.checkboxes){
            let checkboxResults = [];
            for(let i = 0; i < nextProps.checkboxes.length; i++){
                checkboxResults.push(nextProps.checkboxes[i].default);
            }
            this.setState({checkboxResults});
        }
    }

    checkboxChanged(index, value){
        this.setState(state => {
            let checkboxResults = state.checkboxResults;
            checkboxResults[index] = value
            return {checkboxResults};
        });
    }


    render() {
        const {
            onConfirm,
            onCancel,
            title = "",
            showCancel,
            message = "",
            options = null,
            checkboxes = null,
        } = this.props;

        const { checkboxResults } = this.state;

        return (
            <div className="confirm" ref={div => this.processing = div}>
                <div className="confirm__top">
                    <h2>{title}</h2>
                    <div className="confirm__top__close" onClick={onCancel}>
                        <img src={`${ApplicationContext.assetUrlPrefix}/assets/icons/close.svg`}/>
                    </div>
                </div>
                <div className="confirm__body">
                    <p className="confirm__body__text" dangerouslySetInnerHTML={{__html: message}}></p>

                    {
                        checkboxes && checkboxes.map((checkbox, index)=>
                            <React.Fragment key={index}>
                                <label>
                                <input type="checkbox" name="confirm" className="checkbox" checked={checkboxResults[index]} onChange={e=>this.checkboxChanged(index, e.target.checked)}/> 
                                {checkbox.message}
                                </label>
                            </React.Fragment>
                        )
                    }

                    <div className="confirm__body__buttons">

                        {showCancel && <button className="confirm__body__buttons__cancel button" onClick={onCancel}>Cancel</button>}

                        { 
                            options && options.map((option, index)=> 
                                <button key={index} className="button" onClick={()=> onConfirm(index, checkboxResults)}>{option}</button>
                            )
                        }
                        { 
                            !options &&  <button className="button" onClick={()=> onConfirm(0, checkboxResults)}>OK</button>
                        }

                    </div>
                </div>
            </div>
        );
    }
};

module.exports = Confirm;